const CustomAnalysisActionTypes = {
  SET_INITIALIZED: "customAnalysis/SET_INITIALIZED",
  SET_LOADING: "customAnalysis/SET_LOADING",
  SET_FILTERS: "customAnalysis/SET_FILTERS",
  SET_FILTER: "customAnalysis/SET_FILTER",
  SET_ATTENDANCE: "customAnalysis/SET_ATTENDANCE",
  SET_ATTENDANCE_STATS: "customAnalysis/SET_ATTENDANCE_STATS",
  SET_ATTENDANCE_FILTERS: "customAnalysis/SET_ATTENDANCE_FILTERS",
  SET_ATTENDANCE_PEAK_FILTERS: "customAnalysis/SET_ATTENDANCE_PEAK_FILTERS",
  SET_HOURLY_ATTENDANCE_FILTERS: "customAnalysis/SET_HOURLY_ATTENDANCE_FILTERS",
  SET_DOW_ATTENDANCE: "customAnalysis/SET_DOW_ATTENDANCE",
  SET_HOURLY_ATTENDANCE: "customAnalysis/SET_HOURLY_ATTENDANCE",
  SET_ATTENDANCE_PEAK: "customAnalysis/SET_ATTENDANCE_PEAK",
  SET_PRESSURE: "customAnalysis/SET_PRESSURE",
  SET_DOW_PRESSURE: "customAnalysis/SET_DOW_PRESSURE",
  SET_AUTO_REFRESH: "customAnalysis/SET_AUTO_REFRESH",
};

export default CustomAnalysisActionTypes;
